<script>
  import { MenuIcon } from 'vue-transformicons'
  import { mapActions, mapGetters } from 'vuex'
  import handleErrorMessages from '@utils/handleErrorMessages'

  export default {
    components: { MenuIcon },
    data () {
      return {
        errors: [],
        successMessage: '',
        drawer: true,
        snackbar: false,
        messages: 0,
        show: true,
      }
    },
    computed: {
      ...mapGetters({
        authError: 'auth/error',
        authSuccess: 'auth/success',
        abuseError: 'abuse/error',
        reportError: 'report/error',
      }),
      currentPage () {
        return this.$route.path
      },
      dashboardIcon () {
        if (this.currentPage.includes('dashboard')) return '#0069ca'
        return '#92929d'
      },
      verificationIcon () {
        if (this.currentPage.includes('verification')) return '#0069ca'
        return '#92929d'
      },
      reportsIcon () {
        if (this.currentPage.includes('reports')) return '#0069ca'
        return '#92929d'
      },
      profileIcon () {
        if (this.currentPage.includes('profile')) return '#0069ca'
        return '#92929d'
      },
      heightBar () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '60'
          case 'sm': return '60'
          case 'md': return '60'
          case 'lg': return '70'
          case 'xl': return '70'
        }
      },
    },
    watch: {
      authError (newError) {
        this.errors = handleErrorMessages(newError, false)
      },
      abuseError (newError) {
        this.errors = handleErrorMessages(newError, false)
      },
      reportError (newError) {
        this.errors = handleErrorMessages(newError, false)
      },
      errors (errors) {
        if (errors.length !== 0) {
          this.snackbar = true
          return
        }
        this.snackbar = false
      },
      authSuccess ({ value, message }) {
        if (value && message) {
          this.successMessage = message
          this.snackbar = true
        }
      },
    },
    created () {
      if (window.innerWidth < 1280) {
        this.drawer = false
      }
    },
    methods: {
      ...mapActions('auth', ['logOut']),
      logoutClick () {
        this.logOut()
      },
    },
  }
</script>

<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      app
      fixed
    >
      <!-- -->
      <v-list denses>
        <v-list-item
          link
          to="/dashboard"
          active-class="highlighted"
          color="blu darken-4"
        >
          <v-list-item-icon>
            <v-avatar
              tile
              width="22"
              height="22"
              class="ml-0"
            >
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
              ><rect
                id="Rectangle-path"
                x="0"
                y="0.035"
                width="32"
                height="32"
                style="fill:none;"
              /><path
                id="Shape"
                :fill="dashboardIcon"
                d="M12.444,0l-10.666,0c-0.982,0 -1.778,0.796 -1.778,1.778l0,7.111c0,0.982 0.796,1.778 1.778,1.778l10.666,0c0.982,0 1.778,-0.796 1.778,-1.778l0,-7.111c0,-0.982 -0.796,-1.778 -1.778,-1.778Zm-1.777,7.111l-7.111,0l0,-3.555l7.111,0l0,3.555Zm1.777,7.111l-10.666,0c-0.982,0 -1.778,0.796 -1.778,1.778l0,14.222c0,0.982 0.796,1.778 1.778,1.778l10.666,0c0.982,0 1.778,-0.796 1.778,-1.778l0,-14.222c0,-0.982 -0.796,-1.778 -1.778,-1.778Zm-1.777,14.222l-7.111,0l0,-10.666l7.111,0l0,10.666Zm19.555,-7.111l-10.666,0c-0.982,0 -1.778,0.796 -1.778,1.778l0,7.111c0,0.982 0.796,1.778 1.778,1.778l10.666,0c0.982,0 1.778,-0.796 1.778,-1.778l0,-7.111c0,-0.982 -0.796,-1.778 -1.778,-1.778Zm-1.778,7.111l-7.111,0l0,-3.555l7.111,0l0,3.555Zm1.778,-28.444l-10.666,0c-0.982,0 -1.778,0.796 -1.778,1.778l0,14.222c0,0.982 0.796,1.778 1.778,1.778l10.666,0c0.982,0 1.778,-0.796 1.778,-1.778l0,-14.222c0,-0.982 -0.796,-1.778 -1.778,-1.778Zm-1.778,14.222l-7.111,0l0,-10.666l7.111,0l0,10.666Z"
              /></svg>
            </v-avatar>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <span class="menu-item">Dashboard</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          to="/all-verifications"
          active-class="highlighted"
          color="blu darken-4"
          :class="currentPage.includes('verification') ? 'highlighted' : ''"
        >
          <v-list-item-icon>
            <v-avatar
              tile
              width="22"
              height="22"
              class="ml-0"
            >
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
              ><rect
                id="Rectangle-path"
                x="0"
                y="0.035"
                width="32"
                height="32"
                style="fill:none;"
              /><path
                id="Shape"
                :fill="verificationIcon"
                d="M20.469,3.201c0.794,-0.005 1.517,0.459 1.841,1.185l0.336,0.736c0.851,1.892 2.365,3.406 4.257,4.257l0.704,0.304c0.991,0.458 1.454,1.608 1.057,2.625l-0.256,0.688c-0.745,1.921 -0.745,4.05 0,5.97l0.272,0.784c0.393,0.995 -0.065,2.123 -1.041,2.561l-0.736,0.336c-1.892,0.851 -3.406,2.366 -4.257,4.258l-0.304,0.704c-0.329,0.731 -1.056,1.201 -1.857,1.2c-0.262,-0.004 -0.522,-0.053 -0.768,-0.144l-0.688,-0.256c-0.964,-0.378 -1.991,-0.568 -3.025,-0.56c-1.013,-0.007 -2.018,0.177 -2.961,0.544l-0.785,0.272c-0.228,0.095 -0.473,0.144 -0.72,0.144c-0.794,0.006 -1.516,-0.459 -1.84,-1.184l-0.337,-0.736c-0.85,-1.892 -2.365,-3.407 -4.257,-4.258l-0.704,-0.224c-0.991,-0.458 -1.454,-1.608 -1.057,-2.625l0.257,-0.688c0.744,-1.92 0.744,-4.049 0,-5.97l-0.273,-0.784c-0.393,-0.994 0.065,-2.122 1.041,-2.561l0.736,-0.336c1.912,-0.867 3.435,-2.412 4.273,-4.337l0.305,-0.704c0.328,-0.732 1.055,-1.202 1.856,-1.201c0.262,0.004 0.522,0.053 0.768,0.144l0.689,0.256c0.958,0.377 1.979,0.567 3.009,0.56c1.012,0.008 2.017,-0.177 2.961,-0.544l0.784,-0.272c0.228,-0.095 0.473,-0.144 0.72,-0.144m0,-3.201c-0.641,0 -1.276,0.12 -1.873,0.352l-0.736,0.272c-0.594,0.223 -1.222,0.337 -1.856,0.336c-0.634,0.001 -1.263,-0.113 -1.857,-0.336l-0.736,-0.272c-2.59,-1 -5.509,0.203 -6.642,2.737l-0.369,0.72c-0.528,1.146 -1.447,2.065 -2.592,2.593l-0.721,0.32c-2.527,1.14 -3.728,4.053 -2.737,6.642l0.273,0.737c0.464,1.194 0.464,2.519 0,3.713l-0.273,0.736c-0.991,2.59 0.21,5.503 2.737,6.642l0.721,0.32c1.162,0.552 2.083,1.508 2.592,2.689l0.321,0.72c1.133,2.534 4.052,3.737 6.642,2.737l0.736,-0.272c1.197,-0.448 2.516,-0.448 3.713,0l0.736,0.272c2.59,1 5.509,-0.203 6.643,-2.737l0.32,-0.72c0.551,-1.162 1.507,-2.083 2.689,-2.593l0.72,-0.32c2.527,-1.139 3.728,-4.052 2.737,-6.642l-0.272,-0.736c-0.465,-1.194 -0.465,-2.519 0,-3.713l0.272,-0.737c0.991,-2.589 -0.21,-5.502 -2.737,-6.642l-0.72,-0.416c-1.146,-0.528 -2.065,-1.447 -2.593,-2.593l-0.32,-0.72c-0.846,-1.892 -2.73,-3.104 -4.802,-3.089l-0.016,0Zm1.088,10.163c-0.208,-0.001 -0.409,0.08 -0.56,0.224l-7.586,7.587l-2.401,-2.385c-0.145,-0.155 -0.348,-0.242 -0.56,-0.242c-0.212,0 -0.415,0.087 -0.56,0.242l-0.849,0.848c-0.151,0.151 -0.236,0.355 -0.236,0.569c0,0.213 0.085,0.418 0.236,0.568l3.762,3.793c0.144,0.155 0.347,0.243 0.56,0.24c0.211,-0.001 0.413,-0.088 0.56,-0.24l8.995,-8.995c0.151,-0.15 0.237,-0.355 0.237,-0.568c0,-0.213 -0.086,-0.418 -0.237,-0.568l-0.848,-0.849c-0.151,-0.144 -0.352,-0.225 -0.561,-0.224l0.048,0Z"
              /></svg>
            </v-avatar>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <span class="menu-item">Verifications</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          to="/reports"
          active-class="highlighted"
          color="blu darken-4"
        >
          <v-list-item-icon>
            <v-avatar
              tile
              width="22"
              height="22"
              class="ml-0"
            >
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
              ><rect
                id="Rectangle-path"
                x="0"
                y="0.035"
                width="32"
                height="32"
                style="fill:none;"
              /><path
                id="Shape"
                :fill="reportsIcon"
                d="M28.444,0l-24.888,0c-1.964,0 -3.556,1.592 -3.556,3.556l0,24.888c0,1.964 1.592,3.556 3.556,3.556l24.888,0c1.964,0 3.556,-1.592 3.556,-3.556l0,-24.888c0,-1.964 -1.592,-3.556 -3.556,-3.556Zm0,28.444l-24.888,0l0,-24.888l24.888,0l0,24.888Zm-12.444,-13.777c2.209,0 4,-1.791 4,-4c0,-2.209 -1.791,-4 -4,-4c-2.209,0 -4,1.791 -4,4c-0.005,1.062 0.415,2.082 1.166,2.833c0.752,0.752 1.772,1.171 2.834,1.167Zm-7.556,10.222l15.112,0c0.464,0.001 0.895,-0.24 1.138,-0.635c0.243,-0.396 0.263,-0.889 0.053,-1.303l-1.636,-3.218c-0.599,-1.19 -1.814,-1.945 -3.147,-1.955l-7.928,0c-1.333,0.01 -2.548,0.765 -3.147,1.955l-1.6,3.218c-0.208,0.408 -0.192,0.894 0.043,1.288c0.235,0.393 0.655,0.639 1.112,0.65Z"
              /></svg>
            </v-avatar>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <span class="menu-item">Reporting Forms</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          to="/profile"
          active-class="highlighted"
          color="blu darken-4"
        >
          <v-list-item-icon>
            <v-avatar
              tile
              width="22"
              height="22"
              class="ml-0"
            >
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
              ><rect
                id="Rectangle-path"
                x="0"
                y="0.035"
                width="32"
                height="32"
                style="fill:none;"
              /><path
                id="Shape"
                :fill="profileIcon"
                d="M29.128,19.34c-0.777,-0.645 -1.205,-1.619 -1.154,-2.629l0,-1.379c-0.051,-1.009 0.377,-1.983 1.154,-2.629l1.283,-1.058c0.603,-0.498 0.759,-1.358 0.368,-2.036l-1.859,-3.206c-0.285,-0.493 -0.81,-0.798 -1.379,-0.802c-0.193,-0.003 -0.384,0.035 -0.561,0.112l-1.603,0.578c-0.358,0.139 -0.739,0.21 -1.123,0.208c-0.614,-0.002 -1.215,-0.18 -1.731,-0.513c-0.377,-0.26 -0.774,-0.491 -1.186,-0.689c-0.902,-0.463 -1.533,-1.325 -1.7,-2.325l-0.272,-1.603c-0.127,-0.784 -0.809,-1.357 -1.603,-1.347l-3.688,0c-0.794,-0.01 -1.476,0.563 -1.603,1.347l-0.272,1.603c-0.154,0.987 -0.758,1.847 -1.636,2.325c-0.413,0.198 -0.809,0.429 -1.186,0.689c-0.516,0.333 -1.117,0.511 -1.731,0.513c-0.384,0.002 -0.765,-0.069 -1.123,-0.208l-1.603,-0.578c-0.177,-0.077 -0.368,-0.115 -0.561,-0.112c-0.569,0.004 -1.094,0.309 -1.379,0.802l-1.827,3.206c-0.387,0.682 -0.224,1.543 0.384,2.036l1.283,1.058c0.778,0.646 1.205,1.62 1.154,2.629l0,1.379c0.051,1.01 -0.376,1.984 -1.154,2.629l-1.283,1.058c-0.608,0.494 -0.771,1.355 -0.384,2.037l1.859,3.206c0.285,0.493 0.81,0.798 1.379,0.801c0.193,0.004 0.384,-0.035 0.561,-0.112l1.603,-0.577c0.358,-0.14 0.739,-0.211 1.123,-0.208c0.614,0.001 1.215,0.179 1.731,0.513c0.377,0.26 0.774,0.491 1.186,0.689c0.902,0.463 1.533,1.325 1.7,2.325l0.272,1.603c0.127,0.784 0.809,1.357 1.603,1.347l3.688,0c0.794,0.01 1.476,-0.563 1.603,-1.347l0.273,-1.603c0.167,-1 0.797,-1.862 1.699,-2.325c0.413,-0.198 0.809,-0.429 1.186,-0.689c0.516,-0.334 1.117,-0.512 1.732,-0.513c0.384,-0.003 0.764,0.068 1.122,0.208l1.603,0.577c0.177,0.077 0.368,0.116 0.561,0.112c0.569,-0.003 1.094,-0.308 1.379,-0.801l1.86,-3.206c0.365,-0.705 0.161,-1.57 -0.481,-2.037l-1.267,-1.058Zm-13.162,5.499c-4.87,0 -8.817,-3.947 -8.817,-8.817c0,-4.87 3.947,-8.818 8.817,-8.818c4.87,0 8.818,3.948 8.818,8.818c0,2.338 -0.929,4.581 -2.583,6.235c-1.654,1.653 -3.896,2.582 -6.235,2.582Zm0,-12.024c-1.771,0 -3.206,1.436 -3.206,3.207c0,1.771 1.435,3.206 3.206,3.206c1.771,0 3.206,-1.435 3.206,-3.206c0,-1.771 -1.435,-3.207 -3.206,-3.207Z"
              /></svg>
            </v-avatar>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <span class="menu-item">My Profile</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          active-class="highlighted"
          color="blu darken-4"
          @click="logoutClick"
        >
          <v-list-item-icon>
            <v-avatar
              tile
              width="22"
              height="22"
              class="ml-0"
            >
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
              ><rect
                id="Rectangle-path"
                x="0"
                y="0.035"
                width="32"
                height="32"
                style="fill:none;"
              /><path
                fill="#92929d"
                d="M31.609,14.72l-9.138,-9.12c-0.167,-0.168 -0.394,-0.263 -0.631,-0.263c-0.237,0 -0.464,0.095 -0.631,0.263l-1.262,1.262c-0.167,0.164 -0.262,0.388 -0.262,0.622c0,0.234 0.095,0.459 0.262,0.623l6.133,6.115l-18.08,0c-0.488,0 -0.889,0.401 -0.889,0.889l0,1.778c0,0.488 0.401,0.889 0.889,0.889l18.08,0l-6.133,6.115c-0.169,0.167 -0.263,0.395 -0.263,0.631c0,0.237 0.094,0.465 0.263,0.632l1.262,1.244c0.167,0.168 0.394,0.263 0.631,0.263c0.237,0 0.464,-0.095 0.631,-0.263l9.138,-9.12c0.25,-0.25 0.391,-0.589 0.391,-0.942l0,-0.676c-0.004,-0.352 -0.144,-0.69 -0.391,-0.942Zm-18.276,13.724l-9.777,0l0,-24.888l9.777,0c0.488,0 0.889,-0.402 0.889,-0.889l0,-1.778c0,-0.488 -0.401,-0.889 -0.889,-0.889l-9.777,0c-1.951,0 -3.556,1.605 -3.556,3.556l0,24.888c0,1.951 1.605,3.556 3.556,3.556l9.777,0c0.488,0 0.889,-0.401 0.889,-0.889l0,-1.778c0,-0.487 -0.401,-0.889 -0.889,-0.889Z"
                style="fill-rule:nonzero;"
              /></svg>
            </v-avatar>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              <span class="menu-item">Logout</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-btn
        v-if="$vuetify.breakpoint.mdAndDown"
        class="ml-5 mt-10 elevation-0"
        color="blue darken-2"
        link
        to="/new-verification"
      >
        <v-icon color="white">
          mdi-plus
        </v-icon>
        <span class="white--text">NEW VERIFICATION</span>
      </v-btn>
    </v-navigation-drawer>

    <v-app-bar
      elevation="0"
      :height="heightBar"
      clipped-left
      app
      class="navigation-header"
    >
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.mdAndDown"
        @click.stop="drawer = !drawer"
      >
        <menu-icon
          v-if="$vuetify.breakpoint.mdAndDown"
          :active="drawer"
          animation="x-cross"
          @click.stop="drawer = !drawer"
        />
      </v-app-bar-nav-icon>
      <!-- -->
      <v-toolbar-title class="ml-2 ml-md-0">
        <v-avatar
          v-if="$vuetify.breakpoint.mdAndDown"
          tile
          height="35"
          width="auto"
          class="mt-0"
        >
          <img
            src="@assets/img/logo.svg"
            alt="AMLexa"
            height="40"
            link
            :to="{ name: 'dashboard' }"
          >
        </v-avatar>
        <v-avatar
          v-if="$vuetify.breakpoint.lgAndUp"
          tile
          height="40"
          width="auto"
        >
          <img
            src="@assets/img/logo.svg"
            alt="AMLexa"
            height="40"
          >
        </v-avatar>
      </v-toolbar-title>
      <v-spacer grow />
      <div v-if="$vuetify.breakpoint.mdAndUp">
        <v-btn
          color="blue darken-2 elevation-0"
          link
          :to="{ name: 'new-verification' }"
        >
          <v-icon color="white">
            mdi-plus
          </v-icon>
          <span class="white--text">NEW VERIFICATION</span>
        </v-btn>
      </div>
      <v-badge
        content="6"
        color="error"
        avatar
      >
        <v-avatar
          tile
          height="24"
          width="24"
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xml:space="preserve"
            xmlns:serif="http://www.serif.com/"
            style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
          ><rect
            id="Rectangle-path"
            x="0"
            y="0.035"
            width="32"
            height="32"
            style="fill:none;"
          /><path
            id="Shape"
            fill="#92929d"
            d="M16,0c2.34,0 4.269,1.758 4.539,4.025c3.814,1.728 6.466,5.568 6.466,10.028l0,7.646l2.546,5.043c0.511,1.013 -0.225,2.21 -1.361,2.21l-7.879,0.002c-0.628,1.775 -2.321,3.046 -4.311,3.046c-1.99,0 -3.683,-1.271 -4.311,-3.046l-7.879,-0.002c-1.136,0 -1.872,-1.197 -1.361,-2.21l2.546,-5.043l0,-7.646c0,-4.46 2.652,-8.3 6.466,-10.028c0.27,-2.267 2.199,-4.025 4.539,-4.025Zm0,6.095c-4.395,0 -7.958,3.563 -7.958,7.958l0,8.009c0,0.238 -0.056,0.473 -0.163,0.686l-1.593,3.157l19.428,0l-1.593,-3.157c-0.107,-0.213 -0.163,-0.448 -0.163,-0.686l0,-8.009c0,-4.395 -3.563,-7.958 -7.958,-7.958Z"
          /></svg>
        </v-avatar>
      </v-badge>

      <v-btn
        text
        icon
        color="white"
        link
        to="/profile"
      >
        <v-avatar
          style="background-color:#e2e2ea;    min-width: 32px!important;"
          height="32"
          width="32"
        >
          <div style="width:18px;height:18px;margin-left:-3px;margin-top:-5px;">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 32 32"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xml:space="preserve"
              xmlns:serif="http://www.serif.com/"
              style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
            ><rect
              id="Rectangle-path"
              x="0"
              y="0.035"
              width="32"
              height="32"
              style="fill:none;"
            /><path
              id="Shape"
              fill="#92929d"
              d="M7.59,8.575c0,-4.736 3.765,-8.575 8.41,-8.575c4.645,0 8.41,3.839 8.41,8.575c0,2.974 -1.484,5.594 -3.739,7.132c5.06,1.93 8.662,6.905 8.662,12.737l0,3.556l-26.666,0l0,-3.556c0,-5.832 3.602,-10.807 8.662,-12.737c-2.255,-1.538 -3.739,-4.158 -3.739,-7.132Zm8.41,4.811c2.606,0 4.718,-2.154 4.718,-4.811c0,-2.657 -2.112,-4.81 -4.718,-4.81c-2.606,0 -4.718,2.153 -4.718,4.81c0,2.657 2.112,4.811 4.718,4.811Zm0,5.228c-5.256,0 -9.53,4.289 -9.639,9.621l19.278,0c-0.109,-5.332 -4.383,-9.621 -9.639,-9.621Z"
            /></svg>
          </div>
        </v-avatar>
      </v-btn>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-content>
      <!-- Provides the application the proper gutter -->
      <v-container
        fluid
        class="pa-1"
      >
        <main
          id="main-container"
          class="main-container"
        >
          <slot />
        </main>

        <v-snackbar
          v-if="errors.length !== 0 || successMessage"
          v-model="snackbar"
          top
          dark
          :color="errors.length !== 0 ? 'error' : 'success'"
        >
          <p
            v-if="errors.length !== 0"
            class="p-block"
          >
            <span
              v-for="(error, i) in errors"
              :key="`snack-profile-${i}`"
              class="white--text p-block"
            >
              {{ error }}
            </span>
          </p>
          <span
            v-else
            class="white--text"
          > {{ successMessage }} </span>
          <v-btn
            dark
            text
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
        <!-- If using vue-router -->
      </v-container>
    </v-content>

    <v-footer
      dark
      app
      inset
      color="blue darken-2"
    >
      <!-- -->
      Amlexa &copy; 2019
    </v-footer>
  </v-app>
</template>

<style lang="scss">
@import '@design';

.container {
  margin: 0 auto;
}

.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 10px!important;
}

.theme--light.v-list-item--active:before, .theme--light.v-list-item--active:hover:before, .theme--light.v-list-item:focus:before {
    opacity: 0!important;
}

.menu-item {
  font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif;
  font-weight: 600;
  font-size: 0.875rem!important;
}

.v-btn {
  border-radius: 10px !important;
}

.v-list-item {
    padding: 0px!important;
}
.tcon-menu__lines {
  width:24px!important;
  border-radius: 0!important;
  height: 3px!important;
  background: #0069ca!important;
    &::before{
      top: 8px!important;
      border-radius: 0!important;
      height: 3px!important;
      background: #0069ca!important;
    }
    &::after{
      top: -8px!important;
      border-radius: 0!important;
      height: 3px!important;
      background: #0069ca!important;
    }
}
.tcon-menu--xcross.tcon-transform .tcon-menu__lines {
    background: 0 0!important;
}
.tcon-menu--xcross.tcon-transform .tcon-menu__lines::after, .tcon-menu--xcross.tcon-transform .tcon-menu__lines::before {
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    top: 0!important;
    width: 24px!important;
}
.highlighted {
  color: #0069ca;
  border-left: 4px solid #0069ca;
  box-sizing: border-box;
  .v-list-item__icon {
    border: none;
    color: #0069ca;
    text-decoration: none !important;
    margin-left: -4px;
  }
  .v-list-item__title {
    color: #0069ca;
  }
}

.navigation-header{
  border-bottom: 1px solid #e2e2ea!important
}

@media screen and (max-width: 1280px){
    .v-overlay {
    top: 60px !important;
  }
  .v-navigation-drawer {
    top: 60px !important;
  }
}

@media screen and (max-width: 960px) {
  .v-toolbar__content > .v-btn.v-btn--icon:first-child + .v-toolbar__title,
  .v-toolbar__extension > .v-btn.v-btn--icon:first-child + .v-toolbar__title {
    padding: 0 !important;
  }
  .v-overlay {
    top: 60px !important;
  }
  .v-navigation-drawer {
    top: 60px !important;
  }

  .v-app-bar.v-app-bar--fixed {
    z-index: 10 !important;
  }

  .tcon-menu__lines,
  .tcon-menu__lines::after,
  .tcon-menu__lines::before {
    height: 3px !important;
  }

  .v-application--is-ltr .v-list-item__action:first-child,
  .v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 15px !important;
  }
}
</style>
